import communityHttpClient from './httpClient';
import COMMUNITY_ENDPOINTS from './endpoints';
import { normalizeListResponse } from './normalizers';

const BASE_URL = COMMUNITY_ENDPOINTS.COMMENTS;

export const getByPost = (postId, params = {}) =>
  communityHttpClient.get(BASE_URL, { params: { post: postId, ...params } });

export const create = (data) =>
  communityHttpClient.post(`${BASE_URL}/`, data);

export const update = (id, data) =>
  communityHttpClient.patch(`${BASE_URL}/${id}/`, data);

export const remove = (id) =>
  communityHttpClient.delete(`${BASE_URL}/${id}/`);

export const toggleLike = (id) =>
  communityHttpClient.post(`${BASE_URL}/${id}/like/`);

export const report = (id, data) =>
  communityHttpClient.post(`${BASE_URL}/${id}/report/`, data);

export const getNormalizedList = async (postId, params = {}) => {
  const response = await getByPost(postId, params);
  const normalized = normalizeListResponse(response.data);
  return normalized.results;
};

export default {
  getByPost,
  create,
  update,
  delete: remove,
  remove,
  toggleLike,
  report,
  getNormalizedList
};
